import React from "react";
import { EmojiPicker } from "frimousse";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";

/**
 * Full emoji picker modal powered by frimousse (search + categories).
 * @param {Object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {(emoji: string) => void} props.onSelect
 * @returns {JSX.Element}
 */
function EmojiPickerModal({ open, onOpenChange, onSelect }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-auto max-w-[min(100vw-2rem,352px)] overflow-hidden p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Choose an emoji</DialogTitle>
        </DialogHeader>
        {open ? (
          <EmojiPicker.Root
            className="isolate flex h-[368px] w-full flex-col bg-ui-card"
            onEmojiSelect={(emoji) => {
              const native = emoji?.emoji;
              if (native && typeof onSelect === "function") {
                onSelect(native);
              }
              onOpenChange(false);
            }}
          >
            <EmojiPicker.Search
              className="z-10 mx-2 mt-2 appearance-none rounded-md border border-ui-border bg-ui-background px-2.5 py-2 text-sm text-ui-foreground placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring"
              placeholder="Search emoji…"
            />
            <EmojiPicker.Viewport className="relative flex-1 outline-none">
              <EmojiPicker.Loading className="absolute inset-0 flex items-center justify-center text-sm text-text-muted">
                Loading…
              </EmojiPicker.Loading>
              <EmojiPicker.Empty className="absolute inset-0 flex items-center justify-center text-sm text-text-muted">
                No emoji found.
              </EmojiPicker.Empty>
              <EmojiPicker.List
                className="select-none pb-1.5"
                components={{
                  CategoryHeader: ({ category, ...props }) => (
                    <div
                      className="bg-ui-card px-3 pb-1.5 pt-3 text-xs font-medium text-text-muted"
                      {...props}
                    >
                      {category.label}
                    </div>
                  ),
                  Row: ({ children, ...props }) => (
                    <div className="scroll-my-1.5 px-1.5" {...props}>
                      {children}
                    </div>
                  ),
                  Emoji: ({ emoji, ...props }) => (
                    <button
                      type="button"
                      className="flex size-8 items-center justify-center rounded-md text-lg text-ui-foreground data-[active]:bg-ui-muted"
                      {...props}
                    >
                      {emoji.emoji}
                    </button>
                  ),
                }}
              />
            </EmojiPicker.Viewport>
          </EmojiPicker.Root>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

export default EmojiPickerModal;
